/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_heat_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a matrix of values to build a heatmap, where each cell's colour encodes its magnitude. Use a header row for column names and a first column for row names — ideal for correlation matrices or expression data.`)
};

const es_heat_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega una matriz de valores para crear un mapa de calor, donde el color de cada celda codifica su magnitud. Usa una fila de cabecera para los nombres de columna y una primera columna para los nombres de fila — ideal para matrices de correlación o datos de expresión.`)
};

const de_heat_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie eine Matrix von Werten ein, um eine Heatmap zu erstellen, bei der die Farbe jeder Zelle ihre Größenordnung kodiert. Verwenden Sie eine Kopfzeile für Spaltennamen und eine erste Spalte für Zeilennamen — ideal für Korrelationsmatrizen oder Expressionsdaten.`)
};

const nl_heat_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak een matrix van waarden om een heatmap te bouwen, waarbij de kleur van elke cel de grootte codeert. Gebruik een headerrij voor kolomnamen en een eerste kolom voor rijnamen — ideaal voor correlatiematrices of expressiedata.`)
};

const fr_heat_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez une matrice de valeurs pour créer une carte de chaleur, où la couleur de chaque cellule encode son ampleur. Utilisez une ligne d'en-tête pour les noms de colonne et une première colonne pour les noms de ligne — idéal pour les matrices de corrélation ou les données d'expression.`)
};

const it_heat_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla una matrice di valori per costruire una mappa di calore, dove il colore di ciascuna cella codifica la sua grandezza. Usa una riga di intestazione per i nomi delle colonne e una prima colonna per i nomi delle righe — ideale per matrici di correlazione o dati di espressione.`)
};

const pt_br2_heat_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma matriz de valores para criar um mapa de calor, em que a cor de cada célula codifica sua magnitude. Use uma linha de cabeçalho para os nomes das colunas e uma primeira coluna para os nomes das linhas — ideal para matrizes de correlação ou dados de expressão.`)
};

const pt_heat_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma matriz de valores para construir um mapa de calor, onde a cor de cada célula codifica a sua magnitude. Use uma linha de cabeçalho para os nomes das colunas e uma primeira coluna para os nomes das linhas — ideal para matrizes de correlação ou dados de expressão.`)
};

const ja_heat_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`値の行列を貼り付けるとヒートマップが作成され、各セルの色がその大きさを表します。ヘッダー行で列名を、最初の列で行名を指定してください — 相関行列や発現データに最適です。`)
};

const zh_heat_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴数值矩阵以构建热力图，每个单元格的颜色代表其数值大小。表头行用于列名，第一列用于行名——非常适合相关性矩阵或表达量数据。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const heat_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.heat_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("heat_intro", locale)
	if (locale === "en") return en_heat_intro(inputs)
	if (locale === "es") return es_heat_intro(inputs)
	if (locale === "de") return de_heat_intro(inputs)
	if (locale === "nl") return nl_heat_intro(inputs)
	if (locale === "fr") return fr_heat_intro(inputs)
	if (locale === "it") return it_heat_intro(inputs)
	if (locale === "pt-BR") return pt_br2_heat_intro(inputs)
	if (locale === "pt") return pt_heat_intro(inputs)
	if (locale === "ja") return ja_heat_intro(inputs)
	return zh_heat_intro(inputs)
};